import React, { useState } from "react";
import { Link } from "react-router-dom";

// Import the IconComponent you created earlier
import IconComponent from '../../common/Iconcomponent/IconComponent';

// Import the type definition from the main section file
import { ServiceItem } from '../../home/OurServicesSection/OurServicesSection';

const ServiceItemComp: React.FC<ServiceItem> = ({ icon, condition, treatment, path }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <li className="list-group-item p-0 mb-3">
      <Link
        to={path}
        className="service-item d-flex align-items-center p-3 bg-white rounded rounded-3 shadow hover-card text-decoration-none"
        style={{
          border: "none",
          transform: hovered ? "translateY(-8px) scale(1.03)" : "translateY(0) scale(1)",
          boxShadow: hovered
            ? "0 10px 20px rgba(0, 0, 0, 0.25), 0 0 20px rgba(0, 0, 0, 0.1)"
            : "0 3px 6px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.4s ease, box-shadow 0.4s ease",
          filter: hovered ? "brightness(1.05)" : "brightness(1)",
          background: "white",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div
          className="icon-container me-3"
          style={{
            transform: hovered ? "scale(1.25) rotate(4deg)" : "scale(1)",
            transition: "transform 0.4s ease",
            filter: hovered ? "drop-shadow(0 0 6px rgba(0, 0, 0, 0.2))" : "none",
          }}
        >
          <IconComponent icon={icon} />
        </div>
        <div
          className="text"
          style={{
            textShadow: hovered ? "0 0 4px rgba(0, 0, 0, 0.15)" : "none",
            transition: "text-shadow 0.4s ease",
          }}
        >
          <span className="text-dark">
            {condition} –{" "}
            <span className="fw-bold text-dark">
              {treatment}
            </span>
          </span>
        </div>
      </Link>
    </li>
  );
};

export default ServiceItemComp;